import { Button, alpha, styled } from '@material-ui/core'

/**
 * @deprecated danger text buttons aren't available until material-ui v5
 */
export const DangerTextButton = styled(Button)(({ theme }) => ({
  color: theme.palette.error.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.error.main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent',
    },
  },
}))

/**
 * @deprecated warning contained buttons aren't available until material-ui v5
 */
export const WarningContainedButton = styled(Button)(({ theme }) => ({
  color: theme.palette.warning.contrastText,
  backgroundColor: theme.palette.warning.main,
  '&:hover': {
    backgroundColor: theme.palette.warning.dark,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.palette.warning.main,
    },
  },
}))
